module.exports = __webpack_public_path__ + "img/aymeric-aveline.abbf8010.png";